/* ==========================================================================
   Scali navigation drawer  --  assets/scali-nav.js

   Takes over the existing hamburger (#toggleMenu / .site-menu-handle) and
   opens this drawer instead of the theme's #site-nav--mobile sidebar.

   It does that with a CAPTURE-phase listener on document. Capture runs
   before the target and before any bubble-phase or jQuery-delegated
   handler, so stopImmediatePropagation() there stops the theme's own
   handler from ever seeing the click. That is what lets this ship without
   editing sections/header.liquid (47KB, on every page).
   ========================================================================== */
(function () {
  'use strict';

  var nav = document.getElementById('scali-nav');
  if (!nav) return;

  var panel   = nav.querySelector('.scn-panel');
  var stack   = nav.querySelector('.scn-stack');
  var back    = nav.querySelector('.scn-back');
  var backLbl = nav.querySelector('.scn-backlabel');
  var title   = nav.querySelector('.scn-title');
  var root    = document.documentElement;

  /* ---------- levels ---------- */
  var levels = {};
  var titles = {};
  Array.prototype.forEach.call(stack.querySelectorAll('.scn-lv'), function (el) {
    var key = el.getAttribute('data-lv');
    levels[key] = el;
    titles[key] = el.getAttribute('data-title') || '';
  });

  var trail = ['root'];
  var lastFocus = null;

  function render() {
    var cur = trail[trail.length - 1];
    Object.keys(levels).forEach(function (k) {
      var el = levels[k];
      el.classList.remove('is-here', 'is-left');
      if (k === cur) el.classList.add('is-here');
      else if (trail.indexOf(k) > -1) el.classList.add('is-left');
      // rows in a level that is not current must leave the tab order
      Array.prototype.forEach.call(el.querySelectorAll('.scn-row'), function (r) {
        if (k === cur) r.removeAttribute('tabindex');
        else r.setAttribute('tabindex', '-1');
      });
    });
    // The head carries nothing at the top level -- no wordmark, no "Menu", just
    // the close button. One level down it names where you are.
    title.textContent = trail.length > 1 ? (titles[cur] || '') : '';
    back.hidden = trail.length < 2;
    if (trail.length > 1) {
      var parent = trail[trail.length - 2];
      backLbl.textContent = parent === 'root' ? 'Back' : (titles[parent] || 'Back');
    }
  }

  function go(key) {
    if (!levels[key]) return;
    trail.push(key);
    render();
    focusHere();
  }

  // Focus the CONTAINER, never the first row. Focusing a row paints a focus
  // ring even when the drawer was opened with a mouse, which looks like a bug.
  // A tabindex="-1" container takes focus silently, screen readers announce the
  // level, and Tab still walks the rows in order.
  function focusHere() {
    var cur = levels[trail[trail.length - 1]] || panel;
    try { cur.focus({ preventScroll: true }); } catch (e) { cur.focus(); }
  }

  /* ---------- open / close ---------- */
  function open() {
    lastFocus = document.activeElement;
    trail = ['root'];
    render();
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    root.classList.add('scn-lock');
    setHandleState(true);
    setTimeout(focusHere, 80);
  }

  function close() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    root.classList.remove('scn-lock');
    setHandleState(false);
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
    }
  }

  function isOpen() { return nav.classList.contains('is-open'); }

  function handles() {
    var list = [];
    var byId = document.getElementById('toggleMenu');
    if (byId) list.push(byId);
    Array.prototype.forEach.call(document.querySelectorAll('.site-menu-handle'), function (el) {
      if (list.indexOf(el) === -1) list.push(el);
    });
    return list;
  }

  function setHandleState(openNow) {
    handles().forEach(function (h) {
      h.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      h.setAttribute('aria-controls', 'scali-nav');
      if (!h.hasAttribute('role')) h.setAttribute('role', 'button');
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '0');
    });
  }
  setHandleState(false);

  /* ---------- intercept the theme's hamburger ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var h = t.closest('#toggleMenu, .site-menu-handle');
    if (!h) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (isOpen()) close(); else open();
  }, true);

  // keyboard activation of the handle, since it is a <div> in the theme
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('#toggleMenu, .site-menu-handle')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (isOpen()) close(); else open();
  }, true);

  /* ---------- drawer's own controls ---------- */
  nav.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-scn-close]')) { e.preventDefault(); close(); return; }

    var backBtn = t.closest('.scn-back');
    if (backBtn) {
      e.preventDefault();
      if (trail.length > 1) { trail.pop(); render(); focusHere(); }
      return;
    }

    var row = t.closest('.scn-row');
    if (!row) return;

    var target = row.getAttribute('data-go');
    if (target) { e.preventDefault(); go(target); return; }

    var flag = row.getAttribute('data-flag');
    if (flag === 'hc') { e.preventDefault(); toggleContrast(row); return; }

    // anything else is a real <a href> -- let the browser follow it
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { close(); return; }
    if (e.key === 'ArrowLeft' && isOpen() && trail.length > 1) {
      trail.pop(); render(); focusHere();
    }
  });

  // keep focus inside the panel while it is open
  document.addEventListener('focusin', function (e) {
    if (!isOpen()) return;
    if (panel.contains(e.target)) return;
    if (e.target.closest && e.target.closest('#toggleMenu, .site-menu-handle')) return;
    focusHere();
  });

  /* ---------- high contrast ---------- */
  function contrastOn() { return root.classList.contains('scn-hc'); }

  function paintContrast() {
    var on = contrastOn();
    Array.prototype.forEach.call(nav.querySelectorAll('[data-flag="hc"]'), function (r) {
      r.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function toggleContrast() {
    var on = !contrastOn();
    root.classList.toggle('scn-hc', on);
    try { localStorage.setItem('scali-hc', on ? '1' : '0'); } catch (e) {}
    paintContrast();
  }
  paintContrast();

  /* ---------- make sure the theme's own sidebar stays shut ----------
     GUARDED, and deliberately so. The first version fired whenever
     #site-nav--mobile gained `active`, and it also stripped `active` from
     #site-overlay. That overlay is SHARED with the search modal and the cart
     drawer: clicking the search icon opened the modal, this closed it in the
     same frame, and search looked dead (taking the recommended-products
     slider inside it with it). Two rules now:
       1. only intervene while OUR drawer is actually open;
       2. never touch #site-overlay -- it is not ours. */
  var ghost = document.getElementById('site-nav--mobile');
  if (ghost) {
    new MutationObserver(function () {
      if (!isOpen()) return;
      if (ghost.classList.contains('active') || ghost.classList.contains('is-active')) {
        ghost.classList.remove('active', 'is-active');
      }
    }).observe(ghost, { attributes: true, attributeFilter: ['class'] });
  }
})();
